export default __webpack_public_path__ + "static/media/Blog-3.9e973fe4.png";